export class SocketClient {
    private baseUrl: string;
    private path: string;
    private ws: WebSocket;
    private handlers = new Map();
    constructor(path: string, baseUrl?: string) {
        this.baseUrl = baseUrl || 'wss://stream.binance.com/';
        this.path = path;
        this.ws = new WebSocket(`${this.baseUrl}${this.path}`);
        this._createSocket();
    }

    setHandler(method: string, callback: Function) {
        if (!this.handlers.has(method)) {
            this.handlers.set(method, []);
        }
        this.handlers.get(method).push(callback);
    }

    isHandlerExist(method: string) {
        return this.handlers.get(method);
    }

    _createSocket() {
        // console.log(`${this.baseUrl}${this.path}`);

        this.ws.onopen = () => {
            // console.log('ws connected');
        };

        this.ws.onclose = () => {
            // console.log('ws closed');
        };

        this.ws.onerror = (err) => {
            // console.log('ws error', err);
        };

        this.ws.onmessage = (msg) => {
            const message = JSON.parse(msg.data);
            if (message.e) {
                if (this.handlers.has(message.e)) {
                    this.handlers.get(message.e).forEach((cb) => {
                        // console.log(message);

                        cb(message.k);
                    });
                }
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/services/SocketClient.ts